import React, { FunctionComponent } from 'react'
import { Form, Input } from 'antd'
import { MobileOutlined } from '@ant-design/icons'
import { PhonePattern } from 'src/commons/utils'

type PhoneInputProps = {
  readOnly?: boolean
}

const PhoneInput: FunctionComponent<PhoneInputProps> = ({ readOnly }) => {
  return (
    <Form.Item
      name="Phone"
      rules={[
        { required: true, message: '请输入手机号' },
        { pattern: PhonePattern, message: '您输入的手机号不正确!' },
      ]}
      validateTrigger="onBlur">
      <Input maxLength={11} placeholder="请输入手机号" prefix={<MobileOutlined />} readOnly={readOnly} />
    </Form.Item>
  )
}

export default PhoneInput
